/**
 * Automatic sign-up overlays are intentionally disabled. Releafa only asks
 * visitors to authenticate after they choose an account-only action, such as
 * saving a listing, leaving a review, claiming a deal, opening Smoke Buddy,
 * or checking out.
 */
export default function SignupPopup() {
  return null;
}
